import FormikHomeAssumptionsZurichOwnLivePage from './FormikHomeAssumptionsZurichOwnLivePage';

export default FormikHomeAssumptionsZurichOwnLivePage;
